<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="purchaseHistory"
      class="elevation-1"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.store_item.name }}</td>
          <td>
            {{ item.description }}
          </td>
          <td>
            <div>{{ listingTitle(item.reservation) }}</div>
          </td>
          <td>
            {{
              formatDate(
                item.reservation.check_in,
                'YYYY MMM Do',
                item.reservation.listing.timezone
              )
            }}
          </td>
          <td>
            {{
              toCurrency(item.total_amount, {
                currency: item?.store_item?.currency || item?.reservation?.listing?.get_currency,
              })
            }}
          </td>
          <td>
            {{ getStatusLabel(item.status) }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import CommonFunctions from 'components/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  data() {
    return {
      headers: [
        { text: 'Item', sortable: false },
        { text: 'Reservation', sortable: false },
        { text: 'Description', sortable: false },
        { text: 'Check-in', sortable: false },
        { text: 'Price', sortable: false },
        { text: 'Status', sortable: false },
      ],
    }
  },
  computed: {
    purchaseHistory() {
      return this.$store.getters.purchaseHistory
    },
  },
  methods: {
    getStatusLabel(status) {
      const statusLabels = {
        pending_capture: 'Pending Approval',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
        '["canceled", "requested"]': 'Cancelled',
      }
      return statusLabels[status.toLowerCase()] || status
    },
  },
  mounted() {
    this.$store.dispatch('getPurchaseHistory')
  },
}
</script>
